/*
  CK Store — "Build your bundle" (mix & match)
  - Tier cards (1 / 2 / 3 sets) with the discount % from the theme editor
  - 1 set  → added straight from the product page (colour from the theme picker + size select)
  - 2+ sets → "Customize your bundle" sheet: every set gets its own design (product),
              colour and size, then a review step and one add-to-cart request
  The discount: AUTOMATIC discounts in Shopify (Admin › Discounts › Amount off order ›
  Percentage, minimum 2 / 3 items, plus a free-shipping discount from 2 items). They count every
  item in the cart, bundle or not, so nothing has to be applied here.
  Optional (legacy): a discount CODE per tier in the block's "Discount code" setting. Codes are
  saved on the cart attribute "_ck_bundle_codes" and CKBundleGuard keeps the right one on the
  cart. When no tier has a code, the guard removes old bundle codes left on a cart.
  Adding to cart never leaves the page: the customer sees an "Added to your cart" message
  (assets/ck-offer.js) and keeps shopping.
  The size is picked in the theme's own variant picker, under the colour.
*/
(function () {
  if (!window.customElements || window.customElements.get('ck-bundle')) return;

  function formatMoney(cents, format, hideDecimals) {
    cents = Math.round(cents);
    var fmt = format || '{{amount}}';
    if (hideDecimals && cents % 100 === 0) {
      fmt = fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}')
               .replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}')
               .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, '{{amount_no_decimals}}')
               .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/, '{{amount_no_decimals}}');
    }
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return fmt;
    var value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  var ICON = {
    close: '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    check: '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    next: '<svg class="ckb-chev" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>',
    back: '<svg class="ckb-chev ckb-chev--back" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>',
    edit: '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h4L19 9l-4-4L4 16v4z"/></svg>',
    ticket: '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M3 7.5A1.5 1.5 0 0 1 4.5 6h15A1.5 1.5 0 0 1 21 7.5V10a2 2 0 0 0 0 4v2.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 16.5V14a2 2 0 0 0 0-4z"/><path d="M14 6.5v11" stroke-dasharray="2 2"/></svg>',
    copy: '<svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8 4l-4 3 2 3 2-1v11h8V9l2 1 2-3-4-3h-2a2 2 0 0 1-4 0z"/></svg>',
    truck: '<svg aria-hidden="true" width="22" height="18" viewBox="0 0 24 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M1 2h13v11H1zM14 6h5l4 4v3h-9z"/><circle cx="5.5" cy="14.5" r="2" fill="#fff"/><circle cx="18" cy="14.5" r="2" fill="#fff"/></svg>',
    grid: '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/></svg>',
    bag: '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>',
    lock: '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    success: '<svg aria-hidden="true" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };


  /* ---------- Bundle code guard (cart) ---------- */
  var CODES_ATTR = '_ck_bundle_codes';
  var LINE_PROP = '_ck_bundle';
  var cartRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');

  function parseCodes(str) {
    var map = {};
    String(str || '').split(',').forEach(function (pair) {
      var kv = pair.split(':');
      var q = parseInt(kv[0], 10);
      var c = String(kv[1] || '').trim();
      if (q > 0 && c) map[q] = c;
    });
    return map;
  }
  function serializeCodes(map) {
    return Object.keys(map).map(Number).sort(function (a, b) { return a - b; })
      .map(function (q) { return q + ':' + map[q]; }).join(',');
  }
  function upper(c) { return String(c || '').toUpperCase(); }
  function codesInCart(cart) {
    var list = [];
    (cart.discount_codes || []).forEach(function (d) { if (d && d.code) list.push(d.code); });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d && d.type === 'discount_code' && d.title && list.map(upper).indexOf(upper(d.title)) === -1) list.push(d.title);
    });
    return list;
  }
  // Every item counts toward the bundle (mix & match across the whole cart)
  function bundleQty(cart) {
    return cart.item_count || 0;
  }
  // Code of the biggest tier the bundle items reach (3 bundle items → 3-item code)
  function neededCode(map, qty) {
    var best = null, bestQ = 0;
    Object.keys(map).forEach(function (k) {
      var q = Number(k);
      if (q <= qty && q > bestQ) { bestQ = q; best = map[k]; }
    });
    return best;
  }

  var CKBundleGuard = {
    pending: null,
    // Automatic discounts: remove bundle codes (and their attribute) left on the cart by the old setup.
    // Resolves { changed }
    clear: function () {
      var job = fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (cart) {
          var saved = parseCodes(cart.attributes && cart.attributes[CODES_ATTR]);
          var all = Object.keys(saved).map(function (k) { return upper(saved[k]); });
          if (!all.length && !(cart.attributes && cart.attributes[CODES_ATTR])) return { changed: false };
          var current = codesInCart(cart);
          var others = current.filter(function (c) { return all.indexOf(upper(c)) === -1; });
          var body = { attributes: {} };
          body.attributes[CODES_ATTR] = '';
          if (others.length !== current.length) body.discount = others.join(',');
          return fetch(cartRoot + 'cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          }).then(function (res) { return { changed: res.ok && others.length !== current.length }; });
        })
        .catch(function () { return { changed: false }; });
      CKBundleGuard.pending = job.then(function (r) { CKBundleGuard.pending = null; return r; });
      return CKBundleGuard.pending;
    },
    // extraMap: {2: 'BNDL2', 3: 'BNDL3'} from the bundle block (saved on the cart)
    // Resolves { changed, code, ok }
    sync: function (extraMap) {
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var job = fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (cart) {
          var saved = parseCodes(cart.attributes && cart.attributes[CODES_ATTR]);
          var map = saved;
          var body = {};
          if (extraMap && Object.keys(extraMap).length) {
            map = Object.assign({}, saved, extraMap);
            if (serializeCodes(map) !== serializeCodes(saved)) {
              body.attributes = {};
              body.attributes[CODES_ATTR] = serializeCodes(map);
            }
          }
          var all = Object.keys(map).map(function (k) { return upper(map[k]); });
          if (!all.length) return { changed: false, code: null, ok: true };
          var current = codesInCart(cart);
          var others = current.filter(function (c) { return all.indexOf(upper(c)) === -1; });
          var mine = current.filter(function (c) { return all.indexOf(upper(c)) > -1; });
          var need = neededCode(map, bundleQty(cart));
          var same = need ? (mine.length === 1 && upper(mine[0]) === upper(need)) : mine.length === 0;
          if (same && !body.attributes) return { changed: false, code: need, ok: true };
          if (!same) body.discount = others.concat(need ? [need] : []).join(',');
          return fetch(cartRoot + 'cart/update.js', { method: 'POST', headers: headers, credentials: 'same-origin', body: JSON.stringify(body) })
            .then(function (res) {
              if (!res.ok) throw new Error('update');
              return res.json();
            })
            .then(function (updated) {
              var nowMine = codesInCart(updated || {}).filter(function (c) { return all.indexOf(upper(c)) > -1; });
              var ok = need ? nowMine.map(upper).indexOf(upper(need)) > -1 : nowMine.length === 0;
              return { changed: !same, code: need, ok: ok };
            });
        })
        .catch(function () { return { changed: false, code: null, ok: false }; });
      CKBundleGuard.pending = job.then(function (r) { CKBundleGuard.pending = null; return r; });
      return CKBundleGuard.pending;
    }
  };
  window.CKBundleGuard = CKBundleGuard;

  // Cart page: re-check the bundle code on load and after every quantity change / removal
  function initCartPage() {
    var cartEl = document.querySelector('[data-ck-cart]');
    if (!cartEl) return;
    var KEY = 'ckb-cart-reload';
    function reloadOnce() {
      var last = 0;
      try { last = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}
      if (Date.now() - last < 8000) return; // never loop
      try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      window.location.reload();
    }
    // Codes are only managed when the bundle block uses them (legacy); otherwise clean old ones once
    var useCodes = cartEl.hasAttribute('data-ck-bundle-codes');
    function check() {
      if (!useCodes) return;
      CKBundleGuard.sync().then(function (r) { if (r.changed && r.ok) reloadOnce(); });
    }
    if (useCodes) check();
    else CKBundleGuard.clear().then(function (r) { if (r.changed) reloadOnce(); });
    var timer = null;
    var items = cartEl.querySelector('[js-cart-items]');
    if (items && window.MutationObserver) {
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(check, 250);
      }).observe(items, { childList: true });
    }
    // Wait for a running check before leaving for checkout
    cartEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="checkout"]');
      if (!btn || !CKBundleGuard.pending) return;
      e.preventDefault();
      CKBundleGuard.pending.then(function () { window.location.href = cartRoot + 'checkout'; });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartPage);
  else initCartPage();

  var uid = 0;

  class CkBundle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      try {
        this.cfg = JSON.parse(this.querySelector('[data-ck-bundle-config]').textContent);
      } catch (e) { return; }
      this._ready = true;
      this.s = this.cfg.strings || {};
      this.products = (this.cfg.products || []).filter(function (p) { return p && p.variants && p.variants.length; });
      this.main = this.products[0];
      this.groups = (this.cfg.groups || []).filter(function (g) { return g && g.title; });
      this.pickerGroup = -1;
      this.tabs = [];   // active collection tab for each step
      if (!this.main) return;
      // Quick View popup or product section — never the whole page
      this.quickView = this.closest('[data-quick-view-modal]');
      this.scope = this.closest('[data-is-quick-view]') || this.closest('.shopify-section') || document;
      this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-ck-tier]'));
      this.id = 'ckb' + (++uid);
      var radioName = this.id + '-tier';
      var preset = this.tiers.find(function (t) { return t.classList.contains('is-selected'); }) || this.tiers[0];
      this.tiers.forEach(function (t) {
        var input = t.querySelector('input');
        input.name = radioName;
        input.checked = t === preset;
      });
      this.sizeSelect = this.querySelector('[data-ckb-single-size]');
      this.btnPrimary = this.querySelector('[data-ckb-customize]');
      this.btnSingle = this.querySelector('[data-ckb-add-single]');
      this.btnBuy = this.querySelector('[data-ckb-buy-now]');
      this.orEl = this.querySelector('[data-ckb-or]');
      this.sets = [];
      this.step = 0;
      this.fromReview = false;

      this.bindPage();
      this.buildSheet();
      this.refreshSizeSelect();
      this.renderPage();
      this.openFromLink();
    }

    // From the cart ("Build your bundle"): ?ck_bundle=N selects the N-item tier,
    // opens the builder for 2+ items, or just shows the block for 1 item
    openFromLink() {
      if (this.quickView || window.__ckbLinkDone) return;
      var want = 0;
      try { want = parseInt(new URLSearchParams(window.location.search).get('ck_bundle'), 10) || 0; } catch (e) { return; }
      if (!want) return;
      var self = this;
      setTimeout(function () {
        if (window.__ckbLinkDone || !self.offsetParent) return; // the visible copy (desktop / mobile) only
        window.__ckbLinkDone = true;
        var tier = self.tiers.find(function (t) { return (parseInt(t.dataset.qty, 10) || 1) === want; }) ||
          self.tiers.filter(function (t) { return (parseInt(t.dataset.qty, 10) || 1) >= want; })[0];
        if (!tier) return;
        tier.querySelector('input').checked = true;
        self.renderPage();
        if (window.ckLenis) window.ckLenis.scrollTo(self, { offset: -140 });
        else self.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (self.selectedTier().qty > 1) setTimeout(function () { self.open(); }, 650);
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete('ck_bundle');
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
      }, 400);
    }

    disconnectedCallback() {
      if (this.sheet && this.sheet.parentNode) this.sheet.parentNode.removeChild(this.sheet);
      document.documentElement.classList.remove('ckb-lock');
    }

    /* ---------- helpers ---------- */
    money(cents) { return formatMoney(cents, this.cfg.moneyFormat, this.cfg.hideDecimals); }
    discounted(cents, d) { return Math.round(cents * (100 - d) / 100); }
    isFixed() { return this.cfg.discountType === 'fixed'; }
    // Bundle price for a list of item prices (cents) with a tier's discount
    bundleTotal(prices, tier) {
      var self = this;
      var compare = prices.reduce(function (a, b) { return a + b; }, 0);
      if (this.isFixed()) return Math.max(0, compare - (tier.amount || 0));
      return prices.reduce(function (sum, p) { return sum + self.discounted(p, tier.discount || 0); }, 0);
    }
    units(count) { return count === 1 ? this.s.unit_one : this.s.unit_other; }
    shortName(p) {
      var n = String(p.name || p.title || '');
      return n.split(/\s+[–—|-]\s+/)[0] || n;
    }

    findVariant(p, sel) {
      return p.variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
      }) || null;
    }

    exactVariant(p, sel) {
      if (!sel || sel.length < p.options.length) return null;
      for (var i = 0; i < p.options.length; i++) if (sel[i] == null) return null;
      return this.findVariant(p, sel);
    }

    // Is this option value orderable with the other choices of the set?
    // Colours/other options ignore the size choice (they are picked first); sizes respect everything.
    valueAvailable(p, sel, idx, value) {
      var sizeIdx = p.sizePos - 1;
      return p.variants.some(function (v) {
        if (!v.available || v.options[idx] !== value) return false;
        return v.options.every(function (o, i) {
          if (i === idx || sel[i] == null) return true;
          if (idx !== sizeIdx && i === sizeIdx) return true;
          return o === sel[i];
        });
      });
    }

    /* ---------- product page ---------- */
    bindPage() {
      var self = this;
      this.tiers.forEach(function (tier) {
        tier.querySelector('input').addEventListener('change', function () { self.renderPage(); });
      });
      this.scope.querySelectorAll('select[name^="options["]').forEach(function (sel) {
        sel.addEventListener('change', function () { self.onMainChange(); });
      });
      this.scope.addEventListener('click', function (e) {
        if (e.target.closest('[data-option-buttons]')) setTimeout(function () { self.onMainChange(); }, 60);
      });
      if (this.sizeSelect) {
        this.sizeSelect.addEventListener('change', function () {
          self.syncMainSize(self.sizeSelect.value);
          if (self.sets[0] && !self.sets[0].touched) self.sets[0] = null;
          self.renderPage();
        });
      }
      document.addEventListener('ck:size-recommended', function (e) {
        var value = e.detail && e.detail.value;
        if (!value || !self.sizeSelect) return;
        var opt = Array.prototype.find.call(self.sizeSelect.options, function (o) { return o.value === value && !o.disabled; });
        if (!opt) return;
        self.sizeSelect.value = value;
        self.syncMainSize(value);
        if (self.sets[0] && !self.sets[0].touched) self.sets[0] = null;
        self.renderPage();
      });
      this.btnPrimary.addEventListener('click', function () {
        if (self.selectedTier().qty > 1) self.open();
        else self.addSingle(false, self.btnPrimary);
      });
      if (this.btnSingle) this.btnSingle.addEventListener('click', function () { self.addSingle(false, self.btnSingle); });
      if (this.btnBuy) this.btnBuy.addEventListener('click', function () { self.addSingle(true, self.btnBuy); });
    }

    onMainChange() {
      var key = this.mainSelection().join('|');
      if (key === this._mainKey) return;
      this._mainKey = key;
      if (this.sets[0] && !this.sets[0].touched) this.sets[0] = null;
      this.refreshSizeSelect();
      this.renderPage();
    }

    mainSelection() {
      var values = [];
      this.scope.querySelectorAll('select[name^="options["]').forEach(function (sel) {
        var idx = parseInt(String(sel.dataset.index || sel.id || '').replace(/\D/g, ''), 10);
        if (idx) values[idx - 1] = sel.value;
      });
      if (!values.length) {
        var first = this.main.variants.find(function (v) { return v.available; }) || this.main.variants[0];
        values = first.options.slice();
      }
      return values;
    }

    mainSel() {
      var sel = this.mainSelection().slice(0, this.main.options.length);
      var pos = this.cfg.sizePosition;
      if (pos && this.sizeSelect) sel[pos - 1] = this.sizeSelect.value;
      return sel;
    }

    mainVariant() { return this.findVariant(this.main, this.mainSel()); }

    refreshSizeSelect() {
      var sel = this.sizeSelect;
      var pos = this.cfg.sizePosition;
      if (!sel || !pos) return;
      var self = this;
      var base = this.mainSelection().slice();
      var firstOk = null;
      Array.prototype.forEach.call(sel.options, function (opt) {
        base[pos - 1] = opt.value;
        var v = self.findVariant(self.main, base);
        var ok = !!(v && v.available);
        opt.disabled = !ok;
        opt.textContent = ok ? opt.value : opt.value + ' — ' + (v ? self.s.sold_out : self.s.unavailable);
        if (ok && firstOk === null) firstOk = opt.value;
      });
      var current = sel.options[sel.selectedIndex];
      if ((!current || current.disabled) && firstOk !== null) {
        sel.value = firstOk;
        this.syncMainSize(firstOk);
      }
    }

    syncMainSize(value) {
      var pos = this.cfg.sizePosition;
      if (!pos) return;
      var chip = Array.prototype.find.call(
        this.scope.querySelectorAll('[data-product-option="option' + pos + '"] [data-option-value]'),
        function (c) { return c.getAttribute('data-option-value') === value; }
      );
      if (chip) { if (!chip.classList.contains('selected')) chip.click(); return; }
      var name = 'options[' + this.cfg.sizeOptionName + ']';
      var sel = Array.prototype.find.call(this.scope.querySelectorAll('select[name^="options["]'), function (s) { return s.name === name; });
      if (sel && sel.value !== value) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    selectedTier() {
      var checked = this.tiers.find(function (t) { return t.querySelector('input').checked; }) || this.tiers[0];
      if (!checked) return { el: null, qty: 1, discount: 0, amount: 0, note: '', code: '' };
      return {
        el: checked,
        qty: parseInt(checked.dataset.qty, 10) || 1,
        discount: parseFloat(checked.dataset.discount) || 0,
        amount: parseFloat(checked.dataset.amount) || 0,
        note: checked.dataset.note || '',
        code: (checked.dataset.code || '').trim()
      };
    }

    renderPage() {
      var self = this;
      var tier = this.selectedTier();
      var v = this.mainVariant();
      var unit = v ? v.price : this.main.variants[0].price;
      var ok = !!(v && v.available);

      this.tiers.forEach(function (t) {
        var qty = parseInt(t.dataset.qty, 10) || 1;
        var info = { discount: parseFloat(t.dataset.discount) || 0, amount: parseFloat(t.dataset.amount) || 0 };
        t.classList.toggle('is-selected', t === tier.el);
        var prices = [];
        for (var k = 0; k < qty; k++) prices.push(unit);
        var total = self.bundleTotal(prices, info);
        var compare = unit * qty;
        var totalEl = t.querySelector('[data-ck-total]');
        if (totalEl) totalEl.textContent = self.money(total);
        var compareEl = t.querySelector('[data-ck-compare]');
        if (compareEl) { compareEl.textContent = self.money(compare); compareEl.hidden = total >= compare; }
        var unitEl = t.querySelector('[data-ck-unit]');
        if (unitEl) unitEl.textContent = self.money(Math.round(total / qty)) + ' ' + fill(self.s.per_unit, { unit: self.s.unit_one });
      });

      var single = fill(this.s.add_single, { unit: this.s.unit_one }) + ' — ' + this.money(unit);
      var primaryLabel = this.btnPrimary.querySelector('[data-ckb-primary-label]');
      var multi = tier.qty > 1;
      this.btnPrimary.classList.toggle('has-chev', multi);
      primaryLabel.textContent = multi ? this.s.customize : (this.s.add_one + ' — ' + this.money(unit));
      this.btnPrimary.disabled = !multi && !ok;
      if (this.orEl) this.orEl.hidden = !multi;
      if (this.btnSingle) {
        this.btnSingle.hidden = !multi;
        this.btnSingle.disabled = !ok;
        this.btnSingle.querySelector('[data-ckb-single-label]').textContent = ok ? single : this.s.sold_out;
      }
      if (this.btnBuy) {
        this.btnBuy.hidden = multi || !this.cfg.showBuyNow;
        this.btnBuy.disabled = !ok;
      }
      if (!multi && !ok) primaryLabel.textContent = this.s.sold_out;
      this.showError('');
    }

    showError(msg) {
      var el = this.querySelector('[data-ck-error]');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    sizeFinderProps(variant, product) {
      var sf = window.CKSizeFinderData;
      if (!sf || !sf.properties || product !== this.main) return null;
      var sizeVal = variant.options[(parseInt(sf.optionPosition, 10) || 1) - 1];
      return sizeVal === sf.size ? sf.properties : null;
    }

    addSingle(buyNow, btn) {
      var self = this;
      var v = this.mainVariant();
      if (!v || !v.available) { this.showError(this.s.sold_out); return; }
      var item = { id: v.id, quantity: 1 };
      var props = this.sizeFinderProps(v, this.main);
      if (props) item.properties = props;
      var labelEl = btn.querySelector('span') || btn;
      var original = labelEl.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading');
      labelEl.textContent = this.s.adding || '…';
      this.showError('');
      this.postItems([item]).then(function (data) {
        if (buyNow) { window.location.href = self.cfg.checkoutUrl || '/checkout'; return; }
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        labelEl.textContent = self.s.added || '✓';
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
          labelEl.textContent = original;
        }, 2200);
        // No redirect: confirm the add and let the customer keep shopping
        self.announce(data && data.items ? data.items : [data]);
      }).catch(function (err) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        labelEl.textContent = original;
        self.showError(err && err.message ? err.message : self.s.error);
      });
    }

    postItems(items, code) {
      var self = this;
      return fetch(this.cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || self.s.error);
          return data;
        });
      }).then(function (data) {
        if (!code) return data;
        return self.applyCode(code).then(function (ok) { self.codeOk = ok; return data; });
      }).then(function (data) {
        // Header count + theme quick cart refresh themselves on this event
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('ck:bundle-added', { detail: { items: items } }));
        if (typeof window.upcartRefreshCart === 'function') {
          try { window.upcartRefreshCart(); } catch (e) {}
        }
        return data;
      });
    }

    /* ---------- bundle discount code ---------- */
    // {2: 'BNDL2', 3: 'BNDL3'} from the tiers of this block
    tierCodes() {
      var map = {};
      this.tiers.forEach(function (t) {
        var c = (t.dataset.code || '').trim();
        var q = parseInt(t.dataset.qty, 10) || 0;
        if (c && q > 1) map[q] = c;
      });
      return map;
    }

    // Saves the codes on the cart and lets the guard put the right one on it.
    // Resolves true when Shopify accepted the code.
    applyCode(code) {
      var self = this;
      return CKBundleGuard.sync(this.tierCodes()).then(function (r) {
        self.appliedCode = r.code || code;
        if (r.ok && r.code) return true;
        // Older cart API: the /discount/ link saves the code for checkout
        return fetch(cartRoot + 'discount/' + encodeURIComponent(self.appliedCode), { credentials: 'same-origin' })
          .then(function () { return false; }, function () { return false; });
      });
    }

    codeBox(code, applied) {
      if (!code) return '';
      return '<div class="ckb-code" data-ckb-code-box>' +
        '<div class="ckb-code__row">' +
          '<span class="ckb-code__icon">' + ICON.ticket + '</span>' +
          '<span class="ckb-code__text"><small>' + esc(applied ? this.s.code_applied : this.s.code_title) + '</small>' +
          '<strong dir="ltr">' + esc(code) + '</strong></span>' +
          '<button type="button" class="ckb-code__copy" data-ckb-copy="' + esc(code) + '">' + esc(this.s.copy_code) + '</button>' +
        '</div>' +
        '<p class="ckb-code__note">' + esc(this.s.code_note) + '</p>' +
      '</div>';
    }

    copyCode(btn) {
      var code = btn.getAttribute('data-ckb-copy');
      var self = this;
      var done = function () {
        btn.textContent = self.s.code_copied;
        btn.classList.add('is-copied');
        setTimeout(function () { btn.textContent = self.s.copy_code; btn.classList.remove('is-copied'); }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () { self.copyFallback(code); done(); });
      } else { this.copyFallback(code); done(); }
    }

    copyFallback(code) {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }

    // "Added to your cart" message (assets/ck-offer.js); falls back to the cart drawer if there is one
    announce(items) {
      if (window.CKOfferUI) { window.CKOfferUI.toast(items); return; }
      if (typeof window.upcartOpenCart === 'function' || document.querySelector('.quick-cart')) this.openCart(false);
    }

    // Opens the cart drawer if there is one; otherwise goes to the cart page (only when asked)
    openCart(forcePage) {
      var self = this;
      if (typeof window.upcartOpenCart === 'function') {
        var refresh = typeof window.upcartRefreshCart === 'function' ? window.upcartRefreshCart() : null;
        Promise.resolve(refresh).then(function () { window.upcartOpenCart(); });
        return;
      }
      var icon = document.querySelector('[data-js-cart-icon]');
      if (icon && document.querySelector('.quick-cart')) {
        setTimeout(function () { icon.click(); }, 150);
        return;
      }
      if (forcePage) window.location.href = self.cfg.cartUrl;
    }

    /* ---------- bundle sets ---------- */
    newSet(pi, prev) {
      var p = this.products[pi];
      var sel = new Array(p.options.length).fill(null);
      var sizeIdx = p.sizePos - 1;
      var colorIdx = p.colorPos - 1;
      var self = this;
      if (p.hasOnlyDefault) return { pi: pi, sel: p.variants[0].options.slice(), touched: false };

      p.options.forEach(function (opt, i) {
        if (i === sizeIdx) return;
        var values = opt.values.map(function (v) { return v.name; });
        var wanted = null;
        if (prev && prev.sel) {
          var prevP = self.products[prev.pi];
          var prevVal = prev.sel[i];
          // same option name → keep the value (e.g. keep "White" when switching design)
          if (prevP && prevP.options[i] && prevP.options[i].name === opt.name && values.indexOf(prevVal) > -1) wanted = prevVal;
        }
        if (wanted == null && p === self.main && i === colorIdx) wanted = self.mainSelection()[i];
        if (wanted != null && !self.valueAvailable(p, sel, i, wanted)) wanted = null;
        if (wanted == null) wanted = values.find(function (val) { return self.valueAvailable(p, sel, i, val); }) || null;
        sel[i] = wanted;
      });

      if (sizeIdx >= 0) {
        var sizes = p.options[sizeIdx].values.map(function (v) { return v.name; });
        var keep = prev && prev.sel && this.products[prev.pi] && this.products[prev.pi].sizePos === p.sizePos ? prev.sel[sizeIdx] : null;
        if (keep != null && sizes.indexOf(keep) > -1 && this.valueAvailable(p, sel, sizeIdx, keep)) sel[sizeIdx] = keep;
        else {
          var avail = sizes.filter(function (val) { return self.valueAvailable(p, sel, sizeIdx, val); });
          if (avail.length === 1) sel[sizeIdx] = avail[0];
        }
      }
      return { pi: pi, sel: sel, touched: false };
    }

    setFromPage() {
      var set = { pi: 0, sel: this.mainSel(), touched: false };
      var v = this.exactVariant(this.main, set.sel);
      if (!v || !v.available) set = this.newSet(0, null);
      return set;
    }

    setVariant(set) {
      if (!set || set.pi == null) return null;
      return this.exactVariant(this.products[set.pi], set.sel);
    }

    setComplete(set) {
      var v = this.setVariant(set);
      return !!(v && v.available);
    }

    missing(set) {
      if (!set || set.pi == null) return 'design';
      var p = this.products[set.pi];
      for (var i = 0; i < p.options.length; i++) {
        if (set.sel[i] == null) return i === p.sizePos - 1 ? 'size' : (i === p.colorPos - 1 ? 'color' : 'option');
      }
      var v = this.exactVariant(p, set.sel);
      if (!v || !v.available) return 'size';
      return null;
    }

    setImage(set) {
      var p = this.products[set.pi];
      var colorIdx = p.colorPos - 1;
      if (colorIdx >= 0 && set.sel[colorIdx] != null && p.colorImages && p.colorImages[set.sel[colorIdx]]) {
        return p.colorImages[set.sel[colorIdx]];
      }
      var v = this.exactVariant(p, set.sel);
      if (v && v.image) return v.image;
      if (colorIdx >= 0 && set.sel[colorIdx] != null) {
        var withImg = p.variants.find(function (x) { return x.options[colorIdx] === set.sel[colorIdx] && x.image; });
        if (withImg) return withImg.image;
      }
      return p.image;
    }

    setMeta(set) {
      var p = this.products[set.pi];
      if (p.hasOnlyDefault) return '';
      // skip options with a single value (e.g. "Adults") — the customer never chose them
      return set.sel.filter(function (x, i) { return x != null && p.options[i] && p.options[i].values.length > 1; }).join(' • ');
    }

    /* ---------- sheet ---------- */
    buildSheet() {
      var self = this;
      var sheet = document.createElement('div');
      sheet.className = 'ckb-sheet';
      sheet.hidden = true;
      sheet.innerHTML =
        '<div class="ckb-sheet__backdrop" data-ckb-close></div>' +
        '<div class="ckb-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="' + this.id + '-title">' +
          '<div class="ckb-sheet__grab" aria-hidden="true"></div>' +
          '<div class="ckb-sheet__header">' +
            '<div><h2 class="ckb-sheet__title" id="' + this.id + '-title">' + esc(this.s.customize) + '</h2>' +
            '<p class="ckb-sheet__count" data-ckb-count></p></div>' +
            '<button type="button" class="ckb-icon-btn" data-ckb-close aria-label="' + esc(this.s.close) + '">' + ICON.close + '</button>' +
          '</div>' +
          '<ol class="ckb-steps" data-ckb-steps></ol>' +
          '<div class="ckb-sheet__body" data-ckb-body data-scroll-lock-ignore></div>' +
          '<div class="ckb-sheet__footer" data-ckb-footer></div>' +
          '<div class="ckb-picker" data-ckb-picker hidden role="dialog" aria-modal="true" aria-labelledby="' + this.id + '-picker">' +
            '<div class="ckb-picker__header">' +
              '<button type="button" class="ckb-icon-btn ckb-picker__back" data-ckb-picker-close aria-label="' + esc(this.s.back) + '">' + ICON.back + '</button>' +
              '<div class="ckb-picker__titles"><h3 class="ckb-picker__title" id="' + this.id + '-picker">' + esc(this.s.choose_a_design) + '</h3>' +
              '<p class="ckb-sheet__count" data-ckb-picker-count></p></div>' +
              '<button type="button" class="ckb-icon-btn" data-ckb-picker-close aria-label="' + esc(this.s.close) + '">' + ICON.close + '</button>' +
            '</div>' +
            '<div class="ckb-picker__filters" data-ckb-picker-filters role="group"></div>' +
            '<div class="ckb-picker__grid" data-ckb-picker-grid data-scroll-lock-ignore></div>' +
          '</div>' +
        '</div>';
      // Inside Quick View the sheet lives in the popup, so its focus trap and scroll lock let it work
      (this.quickView || document.body).appendChild(sheet);
      this.sheet = sheet;
      this.panel = sheet.querySelector('.ckb-sheet__panel');
      this.body = sheet.querySelector('[data-ckb-body]');
      this.footer = sheet.querySelector('[data-ckb-footer]');
      this.stepsEl = sheet.querySelector('[data-ckb-steps]');
      this.countEl = sheet.querySelector('[data-ckb-count]');
      this.picker = sheet.querySelector('[data-ckb-picker]');
      this.pickerGrid = sheet.querySelector('[data-ckb-picker-grid]');
      this.pickerFilters = sheet.querySelector('[data-ckb-picker-filters]');

      sheet.addEventListener('click', function (e) { self.onSheetClick(e); });
      sheet.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          if (!self.picker.hidden) self.closePicker(); else self.close();
          return;
        }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(
          (self.picker.hidden ? self.panel : self.picker).querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'),
          function (n) { return n.offsetParent !== null; }
        );
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    }

    open() {
      var qty = this.selectedTier().qty;
      if (!this.sets[0]) this.sets[0] = this.setFromPage();
      if (this.sets.length > qty) this.sets.length = qty;
      for (var i = 0; i < qty; i++) if (this.sets[i] === undefined) this.sets[i] = null;
      this.qty = qty;
      this.step = 0;
      this.fromReview = false;
      this.done = false;
      this.lastFocus = document.activeElement;
      this.sheet.setAttribute('dir', document.documentElement.getAttribute('dir') || 'ltr');
      this.sheet.hidden = false;
      document.documentElement.classList.add('ckb-lock');
      this.renderSheet();
      var self = this;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { self.sheet.classList.add('is-open'); });
      });
      setTimeout(function () {
        var c = self.sheet.querySelector('.ckb-sheet__header [data-ckb-close]');
        if (c) c.focus();
      }, 60);
    }

    close() {
      var self = this;
      if (this.sheet.hidden) return;
      this.closePicker(true);
      this.sheet.classList.remove('is-open');
      document.documentElement.classList.remove('ckb-lock');
      setTimeout(function () { self.sheet.hidden = true; }, 280);
      if (this.done) { this.sets = []; this.tabs = []; this.done = false; }
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    openPicker() {
      var self = this;
      // open on the collection tab the customer is looking at
      this.pickerGroup = this.activeTab(this.step);
      this.tabs = [];   // active collection tab for each step
      this.renderPicker();
      this.picker.hidden = false;
      requestAnimationFrame(function () { self.picker.classList.add('is-open'); });
      this.pickerGrid.scrollTop = 0;
      var first = this.picker.querySelector('[data-ckb-picker-close]');
      if (first) first.focus();
    }

    renderPicker() {
      var self = this;
      var set = this.sets[this.step];
      var g = this.pickerGroup;
      var shown = 0;
      var html = '';
      this.products.forEach(function (p, pi) {
        if (g >= 0 && (p.group || 0) !== g) return;
        var selected = set && set.pi === pi;
        html += self.designCard(p, pi, selected, selected ? self.setImage(set) : p.image);
        shown++;
      });
      this.pickerGrid.innerHTML = html;
      this.sheet.querySelector('[data-ckb-picker-count]').textContent = fill(this.s.designs_count, { count: shown });

      // type filters (only when the bundle mixes several collections)
      if (this.groups.length > 1) {
        var counts = this.groups.map(function () { return 0; });
        this.products.forEach(function (p) { if (counts[p.group || 0] != null) counts[p.group || 0]++; });
        var f = '<button type="button" class="ckb-filter' + (g < 0 ? ' is-active' : '') + '" data-ckb-filter="-1" aria-pressed="' + (g < 0) + '">' +
          esc(this.s.filter_all || 'All') + ' <span>' + this.products.length + '</span></button>';
        this.groups.forEach(function (grp, gi) {
          if (!counts[gi]) return;
          f += '<button type="button" class="ckb-filter' + (g === gi ? ' is-active' : '') + '" data-ckb-filter="' + gi + '" aria-pressed="' + (g === gi) + '">' +
            esc(grp.title) + ' <span>' + counts[gi] + '</span></button>';
        });
        this.pickerFilters.innerHTML = f;
        this.pickerFilters.hidden = false;
      } else {
        this.pickerFilters.innerHTML = '';
        this.pickerFilters.hidden = true;
      }
    }

    closePicker(instant) {
      var self = this;
      if (!this.picker || this.picker.hidden) return;
      this.picker.classList.remove('is-open');
      if (instant) { this.picker.hidden = true; return; }
      setTimeout(function () { self.picker.hidden = true; }, 220);
      var more = this.body.querySelector('[data-ckb-more]');
      if (more) more.focus();
    }

    designCard(p, pi, selected, img) {
      return '<button type="button" class="ckb-design' + (selected ? ' is-selected' : '') + '" data-ckb-design="' + pi + '" aria-pressed="' + selected + '">' +
        '<span class="ckb-design__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="240" height="240">' : '') + '</span>' +
        '<span class="ckb-design__name">' + esc(this.shortName(p)) + '</span></button>';
    }

    groupOf(pi) { return pi == null ? 0 : (this.products[pi].group || 0); }

    groupCount(g) {
      return this.products.filter(function (p) { return (p.group || 0) === g; }).length;
    }

    // Collection tab shown for a step: the type of the design chosen in that step,
    // else the type of the previous set, else the type of the product being viewed.
    activeTab(step) {
      if (this.groups.length < 2) return -1;
      if (this.tabs[step] != null) return this.tabs[step];
      var set = this.sets[step];
      if (set && set.pi != null) return this.groupOf(set.pi);
      var prev = this.sets[step - 1];
      if (prev && prev.pi != null) return this.groupOf(prev.pi);
      return this.groupOf(0);
    }

    // The 3 designs shown in a step: from the active collection tab only (or from all
    // products when the bundle uses a single collection). The chosen design stays visible.
    visibleDesigns(set, g) {
      var pool = [];
      for (var i = 0; i < this.products.length; i++) {
        if (g < 0 || (this.products[i].group || 0) === g) pool.push(i);
      }
      var list = pool.slice(0, 3);
      var chosen = set && set.pi != null ? set.pi : null;
      if (chosen !== null && pool.indexOf(chosen) > -1 && list.indexOf(chosen) === -1) list[list.length - 1] = chosen;
      return list;
    }

    goTo(step) {
      this.step = step;
      this.renderSheet();
      this.body.scrollTop = 0;
    }

    onSheetClick(e) {
      var copyBtn = e.target.closest('[data-ckb-copy]');
      if (copyBtn) { this.copyCode(copyBtn); return; }
      var t = e.target.closest('[data-ckb-close],[data-ckb-design],[data-ckb-value],[data-ckb-same],[data-ckb-next],[data-ckb-back],[data-ckb-edit],[data-ckb-step],[data-ckb-add],[data-ckb-checkout],[data-ckb-view-cart],[data-ckb-continue],[data-ckb-more],[data-ckb-filter],[data-ckb-tab],[data-ckb-picker-close]');
      if (!t || t.disabled) return;
      var set = this.sets[this.step];

      if (t.hasAttribute('data-ckb-more')) { this.openPicker(); return; }
      if (t.hasAttribute('data-ckb-tab')) {
        this.tabs[this.step] = parseInt(t.getAttribute('data-ckb-tab'), 10);
        this.renderSheet();
        return;
      }
      if (t.hasAttribute('data-ckb-filter')) {
        this.pickerGroup = parseInt(t.getAttribute('data-ckb-filter'), 10);
        this.renderPicker();
        this.pickerGrid.scrollTop = 0;
        return;
      }
      if (t.hasAttribute('data-ckb-picker-close')) { this.closePicker(); return; }

      if (t.hasAttribute('data-ckb-close') || t.hasAttribute('data-ckb-continue')) { this.close(); return; }

      if (t.hasAttribute('data-ckb-design')) {
        var pi = parseInt(t.getAttribute('data-ckb-design'), 10);
        var fromPicker = !!t.closest('[data-ckb-picker]');
        if (!set || set.pi !== pi) {
          this.sets[this.step] = this.newSet(pi, set);
          this.sets[this.step].touched = true;
        }
        if (fromPicker) this.closePicker(true);
        if (this.groups.length > 1) this.tabs[this.step] = this.groupOf(pi);
        this.renderSheet();
        return;
      }
      if (t.hasAttribute('data-ckb-value')) {
        var idx = parseInt(t.getAttribute('data-ckb-index'), 10);
        var val = t.getAttribute('data-ckb-value');
        var p = this.products[set.pi];
        set.sel[idx] = val;
        set.touched = true;
        // a size that no longer exists with the new colour is cleared
        var sizeIdx = p.sizePos - 1;
        if (idx !== sizeIdx && sizeIdx >= 0 && set.sel[sizeIdx] != null && !this.valueAvailable(p, set.sel, sizeIdx, set.sel[sizeIdx])) {
          set.sel[sizeIdx] = null;
        }
        this.renderSheet();
        return;
      }
      if (t.hasAttribute('data-ckb-same')) {
        var prev = this.sets[this.step - 1];
        if (this.isSameAsPrev(set, prev)) {
          // second click = undo: the set goes back to "nothing chosen"
          this.sets[this.step] = null;
          this.renderSheet();
          return;
        }
        var copy = { pi: prev.pi, sel: prev.sel.slice(), touched: true };
        var pp = this.products[prev.pi];
        if (pp.sizePos) copy.sel[pp.sizePos - 1] = null;
        this.sets[this.step] = copy;
        if (this.groups.length > 1) this.tabs[this.step] = this.groupOf(copy.pi);
        this.renderSheet();
        var sizeBlock = this.body.querySelector('[data-ckb-size-block]');
        if (sizeBlock) sizeBlock.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }
      if (t.hasAttribute('data-ckb-next')) {
        var miss = this.missing(set);
        if (miss) { this.showHint(miss); return; }
        if (this.fromReview) { this.fromReview = false; this.goTo(this.qty); return; }
        this.goTo(this.step + 1);
        return;
      }
      if (t.hasAttribute('data-ckb-back')) {
        this.fromReview = false;
        this.goTo(Math.max(0, this.step - 1));
        return;
      }
      if (t.hasAttribute('data-ckb-edit')) {
        this.fromReview = true;
        this.goTo(parseInt(t.getAttribute('data-ckb-edit'), 10) || 0);
        return;
      }
      if (t.hasAttribute('data-ckb-step')) {
        var target = parseInt(t.getAttribute('data-ckb-step'), 10);
        if (target === this.step) return;
        for (var i = 0; i < target; i++) if (!this.setComplete(this.sets[i])) return;
        this.fromReview = false;
        this.goTo(target);
        return;
      }
      if (t.hasAttribute('data-ckb-add')) { this.submit(t, false); return; }
      if (t.hasAttribute('data-ckb-checkout')) { this.submit(t, true); return; }
      if (t.hasAttribute('data-ckb-view-cart')) {
        this.close();
        this.openCart(true);
      }
    }

    isSameAsPrev(set, prev) {
      if (!set || !prev || set.pi == null || set.pi !== prev.pi) return false;
      var pp = this.products[prev.pi];
      return set.sel.every(function (v, k) { return k === pp.sizePos - 1 || v === prev.sel[k]; });
    }

    showHint(miss) {
      var map = { design: this.s.pick_design, color: this.s.pick_color, size: this.s.pick_size, option: this.s.pick_size };
      var hint = this.body.querySelector('[data-ckb-hint]');
      if (hint) {
        hint.textContent = map[miss] || '';
        hint.hidden = false;
      }
      var block = this.body.querySelector('[data-ckb-block="' + miss + '"]') || hint;
      if (block) {
        block.classList.remove('ckb-shake');
        void block.offsetWidth;
        block.classList.add('ckb-shake');
        block.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    renderSheet() {
      var qty = this.qty;
      if (!this.done) this.footer.classList.remove('is-stacked');
      this.panel.classList.toggle('is-compact', !!this.done);
      this.countEl.textContent = fill(this.s.selected_count, { count: qty, units: this.units(qty) });

      // stepper
      var steps = '';
      for (var i = 0; i < qty; i++) {
        var complete = this.setComplete(this.sets[i]);
        var state = (this.done || this.step >= qty || (i < this.step && complete)) ? 'done' : (i === this.step ? 'current' : 'todo');
        if (i > 0) steps += '<li class="ckb-steps__line' + (state !== 'todo' ? ' is-on' : '') + '" aria-hidden="true"></li>';
        steps += '<li class="ckb-steps__item is-' + state + '">' +
          '<button type="button" data-ckb-step="' + i + '"' + (this.done ? ' disabled' : '') + ' aria-current="' + (i === this.step ? 'step' : 'false') + '">' +
          '<span class="ckb-steps__dot">' + (state === 'done' ? ICON.check : (i + 1)) + '</span>' +
          '<span class="ckb-steps__label">' + esc(this.s.unit_title) + ' ' + (i + 1) + '</span></button></li>';
      }
      var payState = this.done ? 'done' : (this.step >= qty ? 'current' : 'todo');
      steps += '<li class="ckb-steps__line' + (payState !== 'todo' ? ' is-on' : '') + '" aria-hidden="true"></li>' +
        '<li class="ckb-steps__item is-' + payState + '">' +
        '<button type="button" data-ckb-step="' + qty + '"' + (this.done ? ' disabled' : '') + ' aria-current="' + (this.step >= qty ? 'step' : 'false') + '">' +
        '<span class="ckb-steps__dot">' + (payState === 'done' ? ICON.check : (qty + 1)) + '</span>' +
        '<span class="ckb-steps__label">' + esc(this.s.payment_step) + '</span></button></li>';
      this.stepsEl.innerHTML = steps;
      this.stepsEl.hidden = this.done;

      if (this.done) this.renderSuccess();
      else if (this.step >= qty) this.renderReview();
      else this.renderStep();

    }

    renderStep() {
      var self = this;
      var i = this.step;
      var set = this.sets[i];
      var prev = i > 0 ? this.sets[i - 1] : null;
      var html = '';
      var title = esc(this.s.unit_title) + ' ' + (i + 1);

      var showSame = prev && this.setComplete(prev);
      if (showSame) {
        var sameActive = this.isSameAsPrev(set, prev);
        html += '<button type="button" class="ckb-same' + (sameActive ? ' is-active' : '') + '" data-ckb-same aria-pressed="' + sameActive + '">' +
          '<span class="ckb-same__icon">' + (sameActive ? ICON.check : ICON.copy) + '</span>' +
          '<span class="ckb-same__text"><strong>' + esc(fill(this.s.same_as, { title: this.s.unit_title, n: i })) + '</strong>' +
          '<small>' + esc(this.s.same_as_sub) + '</small></span>' + ICON.next + '</button>';
        html += '<p class="ckb-label">' + esc(this.s.or_choose) + '</p>';
      } else {
        html += '<p class="ckb-label">' + esc(this.s.choose_design_for) + ' <span class="ckb-accent">' + title + '</span></p>';
      }

      // designs, organised by collection
      var tab = this.activeTab(i);
      html += '<div data-ckb-block="design">';
      if (tab > -1) {
        html += '<div class="ckb-tabs" role="tablist">';
        this.groups.forEach(function (grp, gi) {
          var n = self.groupCount(gi);
          if (!n) return;
          var on = gi === tab;
          var hasPick = set && set.pi != null && self.groupOf(set.pi) === gi;
          html += '<button type="button" role="tab" class="ckb-tab' + (on ? ' is-active' : '') + '" data-ckb-tab="' + gi + '" aria-selected="' + on + '">' +
            (hasPick ? '<span class="ckb-tab__dot" aria-hidden="true"></span>' : '') + esc(grp.title) + '</button>';
        });
        html += '</div>';
      }
      html += '<div class="ckb-designs">';
      this.visibleDesigns(set, tab).forEach(function (pi) {
        var p = self.products[pi];
        var selected = !!(set && set.pi === pi);
        html += self.designCard(p, pi, selected, selected ? self.setImage(set) : p.image);
      });
      html += '</div>';
      var inTab = tab > -1 ? this.groupCount(tab) : this.products.length;
      if (inTab > 3) {
        html += '<button type="button" class="ckb-more" data-ckb-more>' + ICON.grid +
          '<span>' + esc(this.s.more_designs) + '</span>' +
          '<span class="ckb-more__count">' + esc(fill(this.s.designs_count, { count: inTab })) + '</span>' + ICON.next + '</button>';
      }
      html += '</div>';

      if (set && set.pi != null) {
        var p = this.products[set.pi];
        if (!p.hasOnlyDefault) {
          p.options.forEach(function (opt, idx) {
            var isSize = idx === p.sizePos - 1;
            var isColor = idx === p.colorPos - 1;
            if (isSize) return;
            if (opt.values.length < 2) return; // one choice only: chosen for them, nothing to show
            html += self.optionBlock(p, set, opt, idx, isColor);
          });
          if (p.sizePos) html += this.optionBlock(p, set, p.options[p.sizePos - 1], p.sizePos - 1, false, true);
        }
      }
      html += '<p class="ckb-hint" data-ckb-hint hidden></p>';
      this.body.innerHTML = html;

      // footer
      var nextLabel = this.fromReview ? this.s.save_review
        : (i + 1 < this.qty ? this.s.next + ': ' + this.s.unit_title + ' ' + (i + 2) : this.s.next_review);
      var f = '';
      if (i > 0 && !this.fromReview) f += '<button type="button" class="ckb-btn ckb-btn--outline ckb-btn--back" data-ckb-back>' + ICON.back + '<span>' + esc(this.s.back) + '</span></button>';
      var ready = !this.missing(set);
      f += '<button type="button" class="ckb-btn ckb-btn--primary has-chev' + (ready ? '' : ' is-incomplete') + '" data-ckb-next aria-disabled="' + !ready + '"><span>' + esc(nextLabel) + '</span>' + ICON.next + '</button>';
      this.footer.innerHTML = f;
    }

    optionBlock(p, set, opt, idx, isColor, isSize) {
      var self = this;
      var label = isSize ? this.s.select_size : (isColor ? this.s.select_color : (this.s.select_option + ' ' + opt.name));
      var current = set.sel[idx];
      var html = '<div class="ckb-option' + (isSize ? ' ckb-option--size' : '') + '"' +
        (isSize ? ' data-ckb-size-block data-ckb-block="size"' : (isColor ? ' data-ckb-block="color"' : ' data-ckb-block="option"')) + '>' +
        '<p class="ckb-label">' + esc(label) + (isColor && current ? ': <span class="ckb-muted">' + esc(current) + '</span>' : '') + '</p>' +
        '<div class="' + (isColor ? 'ckb-swatches' : 'ckb-chips') + '">';
      opt.values.forEach(function (val) {
        var ok = self.valueAvailable(p, set.sel, idx, val.name);
        var on = current === val.name;
        var attrs = ' data-ckb-index="' + idx + '" data-ckb-value="' + esc(val.name) + '" aria-pressed="' + on + '"' + (ok ? '' : ' disabled');
        if (isColor) {
          var style = val.img ? 'background-image:url(' + esc(val.img) + ')' : 'background-color:' + esc(val.hex || '#D8D8D8');
          html += '<button type="button" class="ckb-swatch' + (on ? ' is-selected' : '') + (ok ? '' : ' is-out') + '"' + attrs +
            ' aria-label="' + esc(val.name) + '" title="' + esc(val.name) + '"><span style="' + style + '"></span></button>';
        } else {
          html += '<button type="button" class="ckb-chip' + (on ? ' is-selected' : '') + (ok ? '' : ' is-out') + '"' + attrs + '>' + esc(val.name) + '</button>';
        }
      });
      html += '</div></div>';
      return html;
    }

    totals() {
      var tier = this.selectedTier();
      var self = this;
      var prices = [];
      this.sets.slice(0, this.qty).forEach(function (set) {
        var v = self.setVariant(set);
        if (v) prices.push(v.price);
      });
      var compare = prices.reduce(function (a, b) { return a + b; }, 0);
      var total = this.bundleTotal(prices, tier);
      return { compare: compare, total: total, discount: tier.discount, note: tier.note, code: tier.code };
    }

    renderReview() {
      var self = this;
      var t = this.totals();
      var html = '<div class="ckb-review__head"><p class="ckb-review__title">' + esc(this.s.your_bundle) + '</p>' +
        '<button type="button" class="ckb-link" data-ckb-edit="0">' + ICON.edit + esc(this.s.edit) + '</button></div>';
      html += '<ul class="ckb-review">';
      this.sets.slice(0, this.qty).forEach(function (set, i) {
        var p = self.products[set.pi];
        var v = self.setVariant(set);
        var img = self.setImage(set);
        var price = self.isFixed() ? v.price : self.discounted(v.price, t.discount);
        html += '<li class="ckb-review__row">' +
          '<span class="ckb-review__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="160" height="160">' : '') + '</span>' +
          '<span class="ckb-review__info">' +
            '<span class="ckb-review__set">' + esc(self.s.unit_title) + ' ' + (i + 1) + '</span>' +
            '<span class="ckb-review__name">' + esc(self.shortName(p)) + '</span>' +
            (self.setMeta(set) ? '<span class="ckb-review__meta">' + esc(self.setMeta(set)) + '</span>' : '') +
            '<span class="ckb-review__price">' + esc(self.money(price)) +
              (price < v.price ? ' <s>' + esc(self.money(v.price)) + '</s>' : '') + '</span>' +
          '</span>' +
          '<button type="button" class="ckb-link" data-ckb-edit="' + i + '">' + ICON.edit + esc(self.s.edit) + '</button>' +
        '</li>';
      });
      html += '</ul>';
      var saved = t.compare - t.total;
      html += '<div class="ckb-total">' +
        '<div class="ckb-total__row"><span class="ckb-total__label">' + esc(fill(this.s.total_count, { count: this.qty, units: this.units(this.qty) })) + '</span>' +
          (saved > 0 ? '<span class="ckb-pill">' + esc(this.s.you_save) + ' ' + esc(this.money(saved)) + '</span>' : '') + '</div>' +
        (saved > 0 ? '<s class="ckb-total__compare">' + esc(this.money(t.compare)) + '</s>' : '') +
        '<p class="ckb-total__value">' + esc(this.money(t.total)) + '</p>' +
        (t.note ? '<p class="ckb-total__note">' + ICON.truck + '<span>' + esc(t.note) + '</span></p>' : '') +
      '</div>';
      html += this.codeBox(t.code, false);
      html += '<p class="ckb-error" data-ckb-sheet-error role="alert" hidden></p>';
      this.body.innerHTML = html;

      this.footer.innerHTML =
        '<button type="button" class="ckb-btn ckb-btn--outline ckb-btn--back" data-ckb-back>' + ICON.back + '<span>' + esc(this.s.back) + '</span></button>' +
        '<button type="button" class="ckb-btn ckb-btn--primary" data-ckb-add>' + ICON.bag + '<span>' +
          esc(fill(this.s.add_n, { count: this.qty, units: this.units(this.qty) })) + '</span></button>';
    }

    renderSuccess() {
      this.body.innerHTML =
        '<div class="ckb-success">' +
          '<span class="ckb-success__icon">' + ICON.success + '</span>' +
          '<p class="ckb-success__title">' + esc(fill(this.s.added_n, { count: this.qty, units: this.units(this.qty) })) + '</p>' +
          '<p class="ckb-success__sub">' + esc(this.s.added_sub) + '</p>' +
        '</div>' +
        (window.CKOfferUI && this.cartCount ? window.CKOfferUI.statusHtml(this.cartCount) : '') +
        this.codeBox(this.appliedCode || this.selectedTier().code, !!this.codeOk);
      this.footer.innerHTML =
        '<button type="button" class="ckb-btn ckb-btn--primary" data-ckb-continue><span>' + esc(this.s.continue) + '</span></button>' +
        '<button type="button" class="ckb-btn ckb-btn--outline" data-ckb-view-cart><span>' + esc(this.s.view_cart) + '</span></button>';
      this.footer.classList.add('is-stacked');
    }

    submit(btn, checkout) {
      var self = this;
      var sets = this.sets.slice(0, this.qty);
      if (!sets.every(function (s) { return self.setComplete(s); })) {
        var bad = sets.findIndex(function (s) { return !self.setComplete(s); });
        this.goTo(bad < 0 ? 0 : bad);
        return;
      }
      var lines = [];
      var byKey = {};
      sets.forEach(function (set) {
        var p = self.products[set.pi];
        var v = self.setVariant(set);
        var props = self.sizeFinderProps(v, p);
        var key = v.id + (props ? '|sf' : '');
        if (byKey[key]) { byKey[key].quantity += 1; return; }
        var item = { id: v.id, quantity: 1 };
        // hidden tag: this line belongs to a bundle (cart page groups it, the guard counts it)
        item.properties = Object.assign({}, props || {});
        item.properties[LINE_PROP] = String(self.qty);
        byKey[key] = item;
        lines.push(item);
      });
      var label = btn.querySelector('span');
      var original = label.textContent;
      this.sheet.querySelectorAll('[data-ckb-add],[data-ckb-checkout]').forEach(function (b) { b.disabled = true; });
      btn.classList.add('is-loading');
      label.textContent = this.s.adding || '…';
      var err = this.body.querySelector('[data-ckb-sheet-error]');
      if (err) err.hidden = true;

      var code = this.selectedTier().code;
      this.codeOk = false;
      this.appliedCode = '';
      this.postItems(lines, code).then(function () {
        return window.CKOfferUI ? window.CKOfferUI.getCart().then(function (c) { self.cartCount = c.item_count; }, function () {}) : null;
      }).then(function () {
        if (checkout) {
          var url = self.cfg.checkoutUrl || '/checkout';
          // if the cart could not take the code, hand it to checkout in the link
          if (code && !self.codeOk) url += (url.indexOf('?') > -1 ? '&' : '?') + 'discount=' + encodeURIComponent(self.appliedCode || code);
          window.location.href = url;
          return;
        }
        self.done = true;
        self.renderSheet();
      }).catch(function (e) {
        self.sheet.querySelectorAll('[data-ckb-add],[data-ckb-checkout]').forEach(function (b) { b.disabled = false; });
        btn.classList.remove('is-loading');
        label.textContent = original;
        if (err) { err.textContent = e && e.message ? e.message : self.s.error; err.hidden = false; }
      });
    }
  }

  window.customElements.define('ck-bundle', CkBundle);
  window.CKFormatMoney = window.CKFormatMoney || formatMoney;
})();
